export const MODE = Object.freeze({
    EDIT_OVERRIDE: 'EDIT_OVERRIDE',
    ADD_OVERRIDE: 'ADD_OVERRIDE'
});

export { default } from './SplitViewContent';
